module.exports = __webpack_public_path__ + "images/emoji/atm.acf9671aa8b77ab855cb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/atm.png
// module id = sDT+
// module chunks = 1